// src/components/ResumeButton.js

import React from 'react';
import './ResumeButton.css';

const ResumeButton = () => {
  return (
    <div className="resume-button-container">
      <a
        href="https://drive.google.com/uc?export=download&id=1J2LQLEaeKD6a2OrKCF3XoRX3LW4WUiNP"
        target="_blank"
        rel="noopener noreferrer"
        className="resume-button"
      >
        Download Resume
      </a>
    </div>
  );
};

export default ResumeButton;
